import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SkipAuthHeader } from './auth.service';
import { retry, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EthereumService {
  public ethereumPrice: number = 0;

  constructor(private http: HttpClient) {}

  public getCurrentETHPrice(): Observable<{ USD: number }> {
    return timer(0, 20000).pipe(
      retry(5),
      switchMap(() => this.fetchEthereumPrice())
    );
  }

  private fetchEthereumPrice(): Observable<{ USD: number }> {
    return this.http
      .get<{ USD: number }>(
        'https://min-api.cryptocompare.com/data/price?fsym=RIN&tsyms=USD',
        { headers: new HttpHeaders({ [SkipAuthHeader]: 'true' }) }
      )
      .pipe(tap((res) => (this.ethereumPrice = res.USD)));
  }
}
